import CustomerContactsCreateEditForm from './CustomerContactsCreateEditForm';

export default CustomerContactsCreateEditForm;
